<template>
  <v-form ref="form" v-model="valid" lazy-validation>
    <v-card flat>
      <v-select
        data-cy="multi-select"
        v-model="preSelected"
        :loading="loading"
        :items="list"
        chips
        outlined
        multiple
        item-value="id"
        item-text="name"
        :label="label"
        :rules="[rules.required]"
        :placeholder="preSelected && preSelected.length > 0 ? ' ' : placeholder"
        @change="changeSelect"
      >
        <template v-slot:selection="{attrs, item, selected}">
          <v-chip
            class="clear-chips-icon"
            close-icon="$sl-close"
            v-bind="attrs"
            :input-value="selected"
            :rules="[rules.required]"
            close
            @click:close="remove(item)"
            >{{ item.name }}</v-chip
          >
        </template>
      </v-select>
    </v-card>
  </v-form>
</template>

<script>
import {RulesMixin} from '@/components/mixins'
// @group Common
// MultiSelect component
export default {
  name: 'MultiSelect',
  mixins: [RulesMixin],
  props: {
    value: {
      type: Array,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return []
      }
    },
    // list :- is name of the API call ,it is String and is Required
    list: {
      type: Array,
      // Object or array defaults must be returned from
      // a factory function
      default: function () {
        return []
      }
    },
    // label :- is the label of the field, it is String and is Required
    label: {type: String},
    // placeholder :- is the placeholder of the field, it is String and is Required
    placeholder: {type: String, default: 'Välj…'}
  },
  watch: {
    value: {
      handler: function () {
        if (this.value && Object.keys(this.value).length > 0) {
          this.preSelected = this.value
        } else {
          this.preSelected = []
        }
      },
      immediate: true,
      deep: true
    }
  },
  data() {
    return {
      loading: false,
      valid: true,
      types: [],
      preSelected: []
    }
  },
  methods: {
    // @vuese
    // Fire the id:S selected  if v select change
    changeSelect(val) {
      this.$emit('input', this.preSelected)
    },
    remove(item) {
      this.preSelected.splice(this.preSelected.indexOf(item), 1)
      this.preSelected = [...this.preSelected]
      this.$emit('input', this.preSelected)
    }
  }
}
</script>

